module.exports = __webpack_public_path__ + "img/kefu.01be0923.png";